import { useEffect, useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import type { translations } from '@/translations/translations';

interface Props {
  copy: typeof translations.fr.admin.excelFiles.themes.questions;
  count: number;
  open: boolean;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (password: string) => Promise<boolean>;
}

export function ThemeQuestionDeleteConfirmation({ copy, count, open, isPending, onOpenChange, onConfirm }: Props) {
  const [password, setPassword] = useState('');
  const [hasConfirmed, setHasConfirmed] = useState(false);
  useEffect(() => {
    if (!open) { setPassword(''); setHasConfirmed(false); }
  }, [open]);
  const submit = async () => {
    if (!hasConfirmed || !password || isPending) return;
    if (await onConfirm(password)) onOpenChange(false);
  };
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl border-destructive/30 bg-background shadow-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>{copy.deleteConfirmTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {copy.deleteConfirmDescription.replace('{count}', String(count))}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <label className="flex items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-3 text-sm">
          <Checkbox checked={hasConfirmed} onCheckedChange={(value) => setHasConfirmed(value === true)} />
          <span>{copy.deleteAcknowledge}</span>
        </label>
        <label className="space-y-2 text-sm font-medium">
          <span>{copy.deletePassword}</span>
          <Input type="password" autoComplete="current-password" value={password}
            onChange={(event) => setPassword(event.target.value)} maxLength={200} />
        </label>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>{copy.cancelSelection}</AlertDialogCancel>
          <AlertDialogAction disabled={!hasConfirmed || !password || isPending}
            onClick={(event) => { event.preventDefault(); void submit(); }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            {copy.confirmDelete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
